import React from "react";

const PercentageCell = (params) => {
    return <>{`${Math.round(params.value * 100)} %`}</>;

};

export default PercentageCell; 
